module.exports = __webpack_public_path__ + "static/media/oak-pm.607e03a6.png";